
import { defineComponent } from 'vue'
import { User } from "../../models/User";

export default defineComponent({
  name: "OktaLogin",
  props: {
    access_token: String,
  },
  async mounted() {
      if (!this.access_token) {
          this.$router.push({ name: "Intro" });
      }
      else {
          await this.$store.state.axiosService.AdminOktaLogin({ access_token: this.access_token })
              .then(async (response:any)=> {
                  await this.$store.dispatch("userstate/setUser", new User(response.firstName, response.lastName, response.domainName, true));
                  this.$store.dispatch('userstate/setAdminCookie', response.encryptedValue);
                  this.$store.dispatch("createAxiosService", { isAdmin: true, adminCookie: response.encryptedValue });
                  this.$router.push({ name: "Intro" });
              })
      }
  }
})
